import { FC } from 'react';
import styles from './interest-group.module.scss';
import classNames from 'classnames';
import checkIcon from 'assets/images/icons/ic_tick_outlined.svg';
import SimpleCard from 'react-components/simple-card/simple-card';
import cloudinary from 'wa-storybook/helpers/cloudinary';

type Props = {
  name: string;
  icon: string;
  isSelected?: boolean;
  onSelect: () => void;
};

const FocusGroup: FC<Props> = ({ name, icon, isSelected, onSelect }: Props) => {
  return (
    <SimpleCard
      as='button'
      noShadow
      onClick={onSelect}
      className={classNames(
        styles.group,
        isSelected && styles['group--selected'],
      )}
    >
      <div className={styles.wrapper}>
        <h3 className={styles.title}>
          <img
            src={cloudinary(icon ?? '', 'w_20', true)}
            alt=''
            className={styles.icon}
          />
          {name}
        </h3>

        {isSelected && (
          <img src={checkIcon} alt='' className={styles['check-icon']} />
        )}
      </div>
    </SimpleCard>
  );
};

export default FocusGroup;
